import Confirm from "./components/Confirm";
import Alert from "@/hive/components/Alert";
import Toast from "@/hive/components/Toast";
import Vue from "vue";
const ConfirmClass = Vue.extend(Confirm);
const AlertClass = Vue.extend(Alert);
const ToastClass = Vue.extend(Toast);

let confirmInstance, alertInstance;
export default {
  async confirm(text) {
    if (!confirmInstance) {
      confirmInstance = new ConfirmClass();
      confirmInstance.$mount(); // pass nothing
      document.body.appendChild(confirmInstance.$el);
    }
    return await confirmInstance.open(text);
  },
  async alert(text) {
    if (!alertInstance) {
      alertInstance = new AlertClass();
      alertInstance.$mount(); // pass nothing
      document.body.appendChild(alertInstance.$el);
    }
    return await alertInstance.open(text);
  },
  toastError(msg) {
    const tc = new ToastClass();
    tc.$mount(); // pass nothing
    document.body.appendChild(tc.$el);
    tc.errorMsg(msg);
  },
  toastSuccess(msg) {
    const tc = new ToastClass();
    tc.$mount(); // pass nothing
    document.body.appendChild(tc.$el);
    tc.successMsg(msg);
  }
};
